import AddTrucker from './AddTrucker';

export default AddTrucker;
